<template>
  <div class="clinic-create-main" v-loader.opacity="loading">
    <div class="sub-header-box">
      <button class="btn-back" type="button" name="button" data-test="btnBack" @click="goBack">
        <IconArrowBack/>
        {{ backButtonLabel }}
      </button>
    </div>

    <div class="title-box">
      <div class="flex-start">
        <div class="">
          <button class="btn-back" type="button" name="button" data-test="btnBack" @click="goBack">
            <IconArrowBack/>
          </button>

          <h2 class="title">{{ $t('createClinic.newClinic') }}</h2>
        </div>
      </div>
    </div>

    <BaseTab :tabs="tabs" :initialtab="tabActive" @tab-activated="switchTab">
      <template v-slot:tab_head_data>
        {{ $t('createClinic.data') }}
      </template>
      <template v-slot:data>
        <ClinicCreateTab v-if="tabActive == 'data'"/>
      </template>
    </BaseTab>
  </div>
</template>

<style lang="scss" scoped>
.title-box {
  .btn-back,
  .flex-start > div:last-child .btn-outline-secondary:last-child {
    display:                          none;
  }
}

@media (max-width: 991px) {
  .sub-header-box,
  .title-box .btn-outline-secondary span {
    display:                          none;
  }
}
</style>

<script>
import ClinicCreateTab from './ClinicCreateTab.vue'

export default {
  name: 'ClinicCreate',
  components: {
    ClinicCreateTab,
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null,
    },
    parentClinicOptions: [
      {value: null, label: 'None'}
    ],
    clinicTemplate: null,
    parentClinicSelected: null,
    tabActive: 'data',
    tabs: ['data'],
  }),
  computed: {
    backButtonLabel() {
      return this.$utils.getPreviousRouteTitle(this) || this.$i18n.t('goBack')
    },
  },
  mounted() {
  },
  methods: {
    switchTab(tab) {
      this.tabActive = tab;
    },
    goBack() {
      this.$router.go(-1)
    },
  }
}
</script>
